import * as si from "react-icons/si";
import { TbLetterT } from "react-icons/tb";
import { DiNodejs } from "react-icons/di";
import { FaChartPie } from "react-icons/fa";
import * as pic from "../components/pictures";
import myFatoorahLogo from "../components/pictures/logos/myFatoorahLogo.png";
import outsystemsLogo from "../components/pictures/logos/outsystems-logo-ring-main.png";
import { videosData } from "../components/videos/videosData";

export const projectsData = [
  {
    id: "creativityFestival2026",
    category: "professional",
    title: "projects.creativityFestival2026.title",
    description: "projects.creativityFestival2026.description",
    summary: "projects.creativityFestival2026.summary",
    companyId: "creativityFestival2026",
    technologies: [
      {
        icon: (
          <si.SiSquarespace className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "Squarespace",
      },
      {
        icon: <si.SiHtml5 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "HTML",
      },
      {
        icon: <si.SiCss3 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "CSS",
      },
      { iconName: "SEO" },
      { iconName: "Responsive Web Design" },
    ],
    cardImage: {
      src: pic.creativityFestival2026Pic,
      alt: "projects.creativityFestival2026.media.0",
    },
    images: [
      {
        src: pic.creativityFestival1,
        alt: "projects.creativityFestival2026.media.1",
      },
      {
        src: pic.creativityFestival2,
        alt: "projects.creativityFestival2026.media.2",
      },
      {
        src: pic.creativityFestival3,
        alt: "projects.creativityFestival2026.media.3",
      },
      {
        src: pic.creativityFestival4,
        alt: "projects.creativityFestival2026.media.4",
      },
    ],
    videos: [
      {
        src: videosData.creativityFestivalArabicHomePage,
        alt: "projects.creativityFestival2026.media.5",
      },
      {
        src: videosData.creativityFestivalAboutPage,
        alt: "projects.creativityFestival2026.media.6",
      },
      {
        src: videosData.creativityFestivalSpeakersPage,
        alt: "projects.creativityFestival2026.media.7",
      },
      {
        src: videosData.creativityFestivalContactPage,
        alt: "projects.creativityFestival2026.media.8",
      },
    ],
  },
  {
    id: "artStudio",
    category: "personal",
    title: "projects.artstudio.title",
    description: "projects.artstudio.description",
    summary: "projects.artstudio.summary",
    descriptionPoints: [0, 1, 2, 3].map(
      (index) => `projects.artstudio.descriptionPoints.${index}`,
    ),
    cardImage: {
      src: pic.artStudio,
      alt: "projects.artstudio.media.0",
    },
    images: [
      {
        src: pic.artStudio1,
        alt: "projects.artstudio.media.1",
      },
      {
        src: pic.artStudio2,
        alt: "projects.artstudio.media.2",
      },
      {
        src: pic.artStudio3,
        alt: "projects.artstudio.media.3",
      },
      {
        src: pic.artStudio4,
        alt: "projects.artstudio.media.4",
      },
      {
        src: pic.artStudio5,
        alt: "projects.artstudio.media.5",
      },
      {
        src: pic.artStudio6,
        alt: "projects.artstudio.media.6",
      },
      {
        src: pic.artStudio7,
        alt: "projects.artstudio.media.7",
      },
      {
        src: pic.artStudio8,
        alt: "projects.artstudio.media.8",
      },
      {
        src: pic.artStudio9,
        alt: "projects.artstudio.media.9",
      },
      {
        src: pic.artStudio10,
        alt: "projects.artstudio.media.10",
      },
    ],
    technologies: [
      {
        icon: (
          <img
            src={outsystemsLogo}
            width={"100px"}
            alt="OutSystems low code development - developers in Kuwait"
          />
        ),
        iconName: "OutSystems",
      },
    ],
    keyFeatures: [
      "projects.artstudio.keyFeatures.0",
      "projects.artstudio.keyFeatures.1",
      "projects.artstudio.keyFeatures.2",
      "projects.artstudio.keyFeatures.3",
      "projects.artstudio.keyFeatures.4",
      "projects.artstudio.keyFeatures.5",
      "projects.artstudio.keyFeatures.6",
      "projects.artstudio.keyFeatures.7",
      "projects.artstudio.keyFeatures.8",
    ],
  },
  {
    id: "ripple",
    category: "freelance",
    companyId: "ripple",
    title: "projects.ripple.title",
    link: "https://rippleshinellc.com",
    linkPlaceHolder: "rippleshinellc.com",
    projectType: "projects.ripple.projectType",
    description: "projects.ripple.description",
    summary: "projects.ripple.summary",
    descriptionPoints: [
      "projects.ripple.descriptionPoints.0",
      "projects.ripple.descriptionPoints.1",
      "projects.ripple.descriptionPoints.2",
      "projects.ripple.descriptionPoints.3",
      "projects.ripple.descriptionPoints.4",
      "projects.ripple.descriptionPoints.5",
    ],
    cardImage: {
      src: pic.ripple,
      alt: "projects.ripple.media.0",
    },
    images: [
      { src: pic.ripple1, alt: "projects.ripple.media.1" },
      { src: pic.ripple2, alt: "projects.ripple.media.2" },
      { src: pic.ripple3, alt: "projects.ripple.media.3" },
      { src: pic.ripple4, alt: "projects.ripple.media.4" },
      { src: pic.ripple5, alt: "projects.ripple.media.5" },
    ],
    videos: [
      {
        src: videosData.rippleHomePageString,
        alt: "projects.ripple.media.6",
      },
      {
        src: videosData.rippleServicesAnimation,
        alt: "projects.ripple.media.7",
      },
    ],
    technologies: [
      {
        icon: <si.SiRuby className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Ruby",
      },
      {
        icon: (
          <si.SiRubyonrails className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "Ruby on Rails",
      },
      {
        icon: (
          <si.SiPostgresql className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "PostgreSQL",
      },
      {
        icon: <si.SiNextdotjs className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Next.js",
      },
      {
        icon: <TbLetterT className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "TypeScript",
      },
      {
        icon: <si.SiHtml5 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "HTML",
      },
      {
        icon: <si.SiCss3 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "CSS",
      },
      {
        icon: (
          <si.SiTailwindcss className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "Tailwind CSS",
      },
    ],
  },
  {
    id: "event-card",
    category: "personal",
    title: "projects.event_card.title",
    link: "https://github.com/Hessah95/event-card",
    linkPlaceHolder: "projects.event_card.linkPlaceHolder",
    description: "projects.event_card.description",
    summary: "projects.event_card.summary",
    cardImage: {
      src: pic.eventCardPic,
      alt: "projects.event_card.media.0",
    },
    videos: [{ src: videosData.eventCard, alt: "projects.event_card.media.1" }],
    technologies: [
      {
        icon: <si.SiNextdotjs className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Next.js",
      },
      {
        icon: <TbLetterT className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "TypeScript",
      },
      {
        icon: <si.SiHtml5 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "HTML",
      },
      {
        icon: <si.SiCss3 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "CSS",
      },
      {
        icon: (
          <si.SiThreedotjs className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "Three.js",
      },
    ],
  },
  {
    id: "phinests-platform",
    category: "professional",
    companyId: "phinests",
    title: "projects.phinests_platform.title",
    projectType: "projects.phinests_platform.projectType",
    link: "https://phinests.com/",
    linkPlaceHolder: "phinests.com",
    description: "projects.phinests_platform.description",
    summary: "projects.phinests_platform.summary",
    note: "projects.phinests_platform.note",
    contributionGroups: [
      {
        title: "projects.contributionGroups.platform",
        descriptionPoints: [0, 1, 9, 3, 4, 5, 6].map(
          (index) => `projects.phinests_platform.descriptionPoints.${index}`,
        ),
      },
      {
        title: "projects.contributionGroups.operations",
        descriptionPoints: [
          "projects.phinests_platform.descriptionPoints.2",
          ...[0, 1, 2, 3].map(
            (index) =>
              `projects.company_admin_dashboard.descriptionPoints.${index}`,
          ),
          "projects.phinests_platform.descriptionPoints.10",
        ],
      },
      {
        title: "projects.contributionGroups.maintenance",
        descriptionPoints: [7, 8].map(
          (index) => `projects.phinests_platform.descriptionPoints.${index}`,
        ),
      },
    ],
    cardImage: {
      src: pic.phinestsWebsite,
      alt: "projects.phinests_platform.media.0",
    },
    images: [
      {
        src: pic.bannerAndServices,
        alt: "projects.phinests_platform.media.1",
      },
      {
        src: pic.professionalsAndPortfolios,
        alt: "projects.phinests_platform.media.2",
      },
      {
        src: pic.featuresAndJoin,
        alt: "projects.phinests_platform.media.3",
      },
      {
        src: pic.phinestsFooter,
        alt: "projects.phinests_platform.media.4",
      },
      {
        src: pic.phinestsArabic,
        alt: "projects.phinests_platform.media.5",
      },
      {
        src: pic.phinestsPhotographyService,
        alt: "projects.phinests_platform.media.6",
      },
      {
        src: pic.phinestsSearch,
        alt: "projects.phinests_platform.media.7",
      },
      { src: pic.admin1, alt: "projects.phinests_platform.media.9" },
      { src: pic.admin2, alt: "projects.phinests_platform.media.10" },
      { src: pic.admin3, alt: "projects.phinests_platform.media.11" },
    ],
    videos: [
      {
        src: videosData.phinestsDarkMode,
        alt: "projects.phinests_platform.media.12",
      },
    ],
    technologies: [
      {
        icon: <si.SiRuby className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Ruby",
      },
      {
        icon: (
          <si.SiRubyonrails className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "Ruby on Rails",
      },
      {
        icon: <TbLetterT className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "TypeScript",
      },
      {
        icon: <si.SiNextdotjs className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Next.js",
      },
      {
        icon: <si.SiStimulus className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "StimulusJS",
      },
      {
        icon: <si.SiTurbo className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Turbo",
      },
      {
        icon: (
          <si.SiPostgresql className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "PostgreSQL",
      },
      {
        icon: <si.SiHtml5 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "HTML",
      },
      {
        icon: <si.SiCss3 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "CSS",
      },
      {
        icon: <si.SiBootstrap className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Bootstrap",
      },
      {
        icon: (
          <si.SiTailwindcss className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "Tailwind CSS",
      },
      {
        icon: <si.SiAlgolia className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Algolia",
      },
      {
        icon: <si.SiTwilio className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Twilio",
      },
      {
        icon: <si.SiSwagger className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Swagger",
      },
      {
        icon: (
          <si.SiCodeclimate className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "Code Climate",
      },
      {
        icon: <si.SiSentry className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Sentry",
      },
      {
        icon: (
          <img
            src={myFatoorahLogo}
            alt=""
            className="icon"
            style={{ width: "1.5rem", height: "1.5rem", objectFit: "contain" }}
          />
        ),
        iconName: "MyFatoorah",
      },
      {
        icon: <FaChartPie className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Chart.js",
      },
    ],
  },
  {
    id: "notewrote-blog",
    category: "personal",
    title: "projects.notewrote_blog.title",
    description: "projects.notewrote_blog.description",
    summary: "projects.notewrote_blog.summary",
    cardImage: { src: pic.notewrote, alt: "projects.notewrote_blog.media.0" },
    images: [
      { src: pic.noteWrote1, alt: "projects.notewrote_blog.media.1" },
      { src: pic.noteWrote2, alt: "projects.notewrote_blog.media.2" },
      { src: pic.noteWrote3, alt: "projects.notewrote_blog.media.3" },
      { src: pic.noteWrote4, alt: "projects.notewrote_blog.media.4" },
      { src: pic.noteWrote5, alt: "projects.notewrote_blog.media.5" },
      { src: pic.noteWrote6, alt: "projects.notewrote_blog.media.6" },
    ],
    technologies: [
      {
        icon: <si.SiRuby className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Ruby",
      },
      {
        icon: (
          <si.SiRubyonrails className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "Ruby on Rails",
      },
      {
        icon: (
          <si.SiPostgresql className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "PostgreSQL",
      },
      {
        icon: <si.SiHtml5 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "HTML",
      },
      {
        icon: <si.SiCss3 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "CSS",
      },
      {
        icon: <si.SiBootstrap className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Bootstrap",
      },
    ],
  },
  {
    id: "expiration-date-tracker",
    category: "personal",
    title: "projects.expiration_date_tracker.title",
    description: "projects.expiration_date_tracker.description",
    summary: "projects.expiration_date_tracker.summary",
    cardImage: {
      src: pic.expirationDatePic,
      alt: "projects.expiration_date_tracker.media.0",
    },
    images: [
      { src: pic.expiryDate1, alt: "projects.expiration_date_tracker.media.1" },
      { src: pic.expiryDate2, alt: "projects.expiration_date_tracker.media.2" },
      { src: pic.expiryDate3, alt: "projects.expiration_date_tracker.media.3" },
      { src: pic.expiryDate4, alt: "projects.expiration_date_tracker.media.4" },
      { src: pic.expiryDate5, alt: "projects.expiration_date_tracker.media.5" },
    ],
    technologies: [
      {
        icon: (
          <si.SiJavascript className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "JavaScript",
      },
      {
        icon: <si.SiReact className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "React",
      },
      {
        icon: <si.SiRedux className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Redux",
      },
      {
        icon: <DiNodejs className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Node.js",
      },
      {
        icon: <si.SiExpress className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Express.js",
      },
      {
        icon: <si.SiMongodb className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "MongoDB",
      },
      {
        icon: <si.SiHtml5 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "HTML",
      },
      {
        icon: <si.SiCss3 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "CSS",
      },
      {
        icon: <si.SiBootstrap className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Bootstrap",
      },
    ],
  },
  {
    id: "YelpCamp",
    category: "personal",
    title: "YelpCamp",
    description: "projects.yelpcamp.description",
    summary: "projects.yelpcamp.summary",
    cardImage: { src: pic.yelpCampPic, alt: "projects.yelpcamp.media.0" },
    images: [
      { src: pic.yelpCamp1, alt: "projects.yelpcamp.media.1" },
      { src: pic.yelpCamp2, alt: "projects.yelpcamp.media.2" },
      { src: pic.yelpCamp3, alt: "projects.yelpcamp.media.3" },
      { src: pic.yelpCamp4, alt: "projects.yelpcamp.media.4" },
      { src: pic.yelpCamp5, alt: "projects.yelpcamp.media.5" },
      { src: pic.yelpCamp6, alt: "projects.yelpcamp.media.6" },
    ],
    technologies: [
      {
        icon: (
          <si.SiJavascript className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "JavaScript",
      },
      {
        icon: <DiNodejs className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Node.js",
      },
      {
        icon: <si.SiExpress className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Express.js",
      },
      {
        icon: <si.SiMongodb className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "MongoDB",
      },
      {
        icon: <si.SiHtml5 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "HTML",
      },
      {
        icon: <si.SiCss3 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "CSS",
      },
      {
        icon: <si.SiBootstrap className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Bootstrap",
      },
    ],
  },
  {
    id: "hessah-store",
    category: "personal",
    title: "projects.hessah_store.title",
    description: "projects.hessah_store.description",
    summary: "projects.hessah_store.summary",
    cardImage: {
      src: pic.hessahStorePic,
      alt: "projects.hessah_store.media.0",
    },
    images: [
      { src: pic.hessahStore1, alt: "projects.hessah_store.media.1" },
      { src: pic.hessahStore2, alt: "projects.hessah_store.media.2" },
      { src: pic.hessahStore3, alt: "projects.hessah_store.media.3" },
      { src: pic.hessahStore4, alt: "projects.hessah_store.media.4" },
      { src: pic.hessahStore5, alt: "projects.hessah_store.media.5" },
      { src: pic.hessahStore6, alt: "projects.hessah_store.media.6" },
      { src: pic.hessahStore7, alt: "projects.hessah_store.media.7" },
      { src: pic.hessahStore8, alt: "projects.hessah_store.media.8" },
      { src: pic.hessahStore9, alt: "projects.hessah_store.media.9" },
      { src: pic.hessahStore10, alt: "projects.hessah_store.media.10" },
    ],
    technologies: [
      {
        icon: (
          <si.SiJavascript className="icon" size="1.5rem" color="#2F4F4F" />
        ),
        iconName: "JavaScript",
      },
      {
        icon: <si.SiReact className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "React",
      },
      {
        icon: <DiNodejs className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Node.js",
      },
      {
        icon: <si.SiExpress className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Express.js",
      },
      {
        icon: <si.SiMongodb className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "MongoDB",
      },
      {
        icon: <si.SiHtml5 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "HTML",
      },
      {
        icon: <si.SiCss3 className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "CSS",
      },
      {
        icon: <si.SiBootstrap className="icon" size="1.5rem" color="#2F4F4F" />,
        iconName: "Bootstrap",
      },
    ],
  },
];
